import { User } from '../admin/admin.types';

export type MailboxMessageAttachmentAssignment = {
  id: number;
  candidateId: number;
  attachment: Attachment;
};

enum VisibilityLevel {
  Public = 'public',
  Protected = 'protected',
  Private = 'private',
}

export type AttachmentSource =
  | 'mailbox'
  | 'candidate'
  | 'guest'
  | 'open_question'
  | 'result'
  | 'note'
  | 'offer'
  | 'requisition'
  | 'requisition_approval_request'
  | 'talent_pool';

export type AttachmentKind = 'image' | 'document' | 'other';

export type Attachment = {
  admin: User;
  adminId: number;
  candidate?: any | null;
  candidateId: number | null;
  createdAt: string;
  extension: string;
  fileSize: number;
  fileUrl: string;
  filename: string;
  guest?: any;
  guestId?: number;
  id: number;
  imageThumbnailUrl?: string;
  imageUrl?: string;
  kind: AttachmentKind;
  offerId: number | null;
  talentPoolId: number | null;
  originalFileUrl?: string;
  pdfThumbnailUrl?: string;
  pdfUrl?: string;
  private: boolean;
  requisitionId?: number | null;
  source: AttachmentSource;
  status: string;
  uploader: string;
  visibility?: {
    adminIds: number[];
    level: VisibilityLevel;
    roleIds: number[];
  };
};
